import { defineComponent as a, openBlock as r, createBlock as p, unref as l, mergeProps as m, withCtx as c, createElementVNode as o } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const s = /* @__PURE__ */ a({
  name: "IconSmartphone",
  __name: "IconSmartphone",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (h, e) => (r(), p(l(d), m(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        o("path", { d: "M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2M10.5 4.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3" }, null, -1),
        o("path", {
          "fill-rule": "evenodd",
          d: "M5.25 5.5A3.25 3.25 0 0 1 8.5 2.25h7a3.25 3.25 0 0 1 3.25 3.25v13a3.25 3.25 0 0 1-3.25 3.25h-7a3.25 3.25 0 0 1-3.25-3.25v-13M8.5 3.75A1.75 1.75 0 0 0 6.75 5.5v13a1.75 1.75 0 0 0 1.75 1.75h7a1.75 1.75 0 0 0 1.75-1.75v-13a1.75 1.75 0 0 0-1.75-1.75h-7",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
